import "./TopHeader.css";
import Logo from "../../../assets/images/SA-Logo-Main.png";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import { IoSearchSharp } from "react-icons/io5";
import MenuImg from "../../../assets/images/toggle_pic.png";
import { useState } from "react";

function TopHeader() {
  const [isMenuOpn, setIsMenuOpn] = useState(false);

  return (
    <>
      <section className="topHeaderWrapper">
        <div className={isMenuOpn ? "topHeader movedHeader" : "topHeader"}>
          <Navbar expand="lg" className="bg-body-tertiary headerContent">
            <Container>
              <Navbar.Toggle
                onClick={() => setIsMenuOpn(!isMenuOpn)}
                aria-controls="basic-navbar-nav"
              >
                MENU <img src={MenuImg} />
              </Navbar.Toggle>
              <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="me-auto">
                  <Nav.Link href="https://www.signafrica.com/">Home</Nav.Link>
                  <Nav.Link href="https://www.signafrica.com/news/">
                    NEWS
                  </Nav.Link>
                  <Nav.Link href="https://www.signafrica.com/live/">
                    LIVE
                  </Nav.Link>
                  <Nav.Link href="https://signafricaexpo.com/" target="_blank">
                    EXPOS
                  </Nav.Link>
                  <Nav.Link href="https://hub.signafrica.com/deals/companies">
                    DIRECTORY
                  </Nav.Link>
                  <Nav.Link href="https://hub.signafrica.com/classifieds">
                    BUY & SELL
                  </Nav.Link>
                  <Nav.Link href="https://hub.signafrica.com/job-types">
                    JOBS
                  </Nav.Link>
                  <Nav.Link href="https://www.signafrica.com/magazine/">
                    MAGAZINE
                  </Nav.Link>
                  <Nav.Link href="https://www.signafrica.com/calendar/">
                    EVENTS
                  </Nav.Link>
                  <Nav.Link href="https://www.signafrica.com/subscribe/">
                    SUBSCRIBE
                  </Nav.Link>
                  <Nav.Link href="https://hub.signafrica.com/deals/latest-deals">
                    DEALS
                  </Nav.Link>
                  {/* <NavDropdown title="EXPOS" id="basic-nav-dropdown">
                    <NavDropdown.Item
                      href="https://www.signafricaexpo.com/"
                      target="_blank"
                    >
                      Sign Africa Expo
                    </NavDropdown.Item>
                    <NavDropdown.Item
                      href="https://africaprintexpo.com/"
                      target="_blank"
                    >
                      Africa Print
                    </NavDropdown.Item>
                    <NavDropdown.Item href="https://graphicsprintsign.com/">
                      Graphics Print & Sign
                    </NavDropdown.Item>
                  </NavDropdown> */}
                </Nav>
              </Navbar.Collapse>
            </Container>
          </Navbar>
        </div>
        <div className={isMenuOpn ? "logoImgMargin" : "logoImg"}>
          <img src={Logo} alt="news-logo" />
        </div>
      </section>
    </>
  );
}

export default TopHeader;
